// locales which we support (including date formats)
export enum ELanguage {
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  DE = 'de',
  PL = 'pl',
  SK = 'sk',
}
